import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/es/checklists")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
